var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 24,
    viewBox: "0 0 117 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6751 4.4024H0V0.102661H17.6751V4.4024Z",
    fill: "#A1E2C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6751 10.9239H0V6.62512H17.6751V10.9239Z",
    fill: "#A1E2C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6751 17.4462H0V13.1465H17.6751V17.4462Z",
    fill: "#A1E2C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6751 23.9668H0V19.668H17.6751V23.9668Z",
    fill: "#A1E2C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5239 24V0H30.0449C33.9807 0 37.0601 1.10228 39.2501 3.34012C41.4751 5.54373 42.5696 8.4359 42.5696 12.0518C42.5696 15.6678 41.4751 18.559 39.2851 20.7331C37.0951 22.9072 34.0147 24.0048 30.0789 24.0048L21.5239 24ZM25.8038 20.1092H29.7736C35.6933 20.1092 38.2945 16.9755 38.2945 12.0518C38.2945 6.99029 35.7274 3.89079 29.7386 3.89079H25.8038V20.1092Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.752 24V0H55.0262C57.1822 0 58.996 0.722806 60.5017 2.20361C62.0046 3.65017 62.7607 5.44006 62.7607 7.60848C62.7607 10.7422 61.0159 13.3244 58.4128 14.4266L64.1974 24H59.3722L54.2729 15.4604H50.0299V24H45.752ZM50.0299 11.6029H54.581C56.9081 11.6029 58.5168 9.98613 58.5168 7.67791C58.5168 5.4743 56.9761 3.88984 54.9251 3.88984H50.0299V11.6029Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7979 24V0H71.0786V24H66.7979Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6685 24L73.813 0H78.3301L85.4455 17.664L92.5657 0H97.0827L87.2272 24H83.6685Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4561 24L103.415 0H107.041L117 24H112.483L110.532 19.2114H99.924L97.9731 23.9981L93.4561 24ZM101.259 15.6668H109.198L105.228 5.88801L101.259 15.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.d004c3977077d364568feadaec5b233c.svg";
export { ForwardRef as ReactComponent };